"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilitaryExperienceType = void 0;
var MilitaryExperienceType;
(function (MilitaryExperienceType) {
    MilitaryExperienceType["NONE"] = "NO";
    MilitaryExperienceType["ACTIVE_DUTY"] = "AC";
    MilitaryExperienceType["RETIRED_DISCHARGED_SEPARATED"] = "RT";
    MilitaryExperienceType["RESERVE_OR_NATIONAL_GUARD"] = "RS";
    MilitaryExperienceType["SURVIVING_SPOUSE"] = "SP";
})(MilitaryExperienceType = exports.MilitaryExperienceType || (exports.MilitaryExperienceType = {}));
